import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import React__default, { useRef, useState, useImperativeHandle, useCallback, useEffect } from 'react';
import { useMountedState } from 'react-use';
import Collapse from './Collapse/index.js';

var noop = function noop(v) {
  return v;
};

var _NotificationSlot = /*#__PURE__*/React__default.forwardRef(function NotificationSlot(_ref, ref) {
  var _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? noop : _ref$transform;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _slicedToArray(_useState2[0], 2),
      node = _useState2$[0],
      meta = _useState2$[1],
      setState = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      active = _useState4[0],
      setActive = _useState4[1];

  var timeout = useRef();

  var enterTimeout = useRef();

  var mounted = useMountedState();
  useImperativeHandle(ref, function () {
    return {
      push: function push(node) {
        var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (timeout.current) clearTimeout(timeout.current);

        if (active) {
          setActive(false);
          if (enterTimeout.current) clearTimeout(enterTimeout.current); // wait 300ms until the collapse panel collapsed

          enterTimeout.current = _setTimeout(function () {
            if (mounted()) {
              setState([node && transform(node), meta]);
              setActive(true);
            }
          }, 300);
        } else {
          if (mounted()) {
            setState([node && transform(node), meta]);
            setActive(true);
          }
        }
      },
      repaint: function repaint(node) {
        var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (timeout.current) clearTimeout(timeout.current);
        setState([node && transform(node), meta]);
        setActive(true);
      }
    };
  }, [active, mounted, transform]);
  var startTimeout = useCallback(function () {
    if ((meta === null || meta === void 0 ? void 0 : meta.timeout) !== 0) {
      timeout.current = _setTimeout(function () {
        if (mounted()) {
          setActive(false);
        }
      }, (meta === null || meta === void 0 ? void 0 : meta.timeout) || 3000);
    }
  }, [meta === null || meta === void 0 ? void 0 : meta.timeout, mounted]); // if node has changed, we start the timeout

  var lastNode = useRef();

  useEffect(function () {
    if (lastNode.current !== node && node) {
      lastNode.current = node;
      startTimeout();
    }
  }, [node, meta, startTimeout, mounted]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "smb-notification-slot"
  }, /*#__PURE__*/React__default.createElement(Collapse.Panel, {
    active: active,
    unmountOnExit: true
  }, /*#__PURE__*/React__default.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      if (timeout.current) clearTimeout(timeout.current);
    },
    onMouseLeave: startTimeout
  }, node)));
});

var NotificationSlot = _Object$assign(_NotificationSlot, {
  useRef: function useRef$1() {
    return useRef(null);
  }
});

export { NotificationSlot as N };
